(function () {
  const sectionSelector = '[data-rx-value-prop-section]';
  let variantSubscriptionReady = false;

  function getSections(root = document) {
    return root.querySelectorAll(sectionSelector);
  }

  function getProductData() {
    const productData = document.getElementById('product-data');
    if (!productData) return null;

    try {
      return JSON.parse(productData.textContent);
    } catch (error) {
      console.warn('RX value prop product data parse error:', error);
      return null;
    }
  }

  function getCurrentVariant(product, fallbackVariant = null) {
    if (fallbackVariant) return fallbackVariant;
    if (!product?.variants?.length) return null;

    const variantIdFromUrl = new URLSearchParams(window.location.search).get('variant');
    const activeVariant = document.querySelector('.product-section__variant-thumbnail.is-active[data-variant-id]');
    const variantId = variantIdFromUrl || activeVariant?.dataset.variantId;

    return product.variants.find((variant) => String(variant.id) === String(variantId)) || product.variants[0];
  }

  function formatMoney(cents) {
    const pricing = window.WMPRxDynamicPricing || window.WMPFramesStartingAt;

    if (typeof pricing?.formatMoney === 'function') {
      return pricing.formatMoney(cents);
    }

    const amount = cents / 100;
    const currency = window.Shopify?.currency?.active || 'USD';
    const hasFraction = !Number.isInteger(amount);

    try {
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency,
        minimumFractionDigits: hasFraction ? 2 : 0,
        maximumFractionDigits: 2
      }).format(amount);
    } catch (error) {
      return `$${hasFraction ? amount.toFixed(2) : amount.toFixed(0)}`;
    }
  }

  function getPriceData(detail = null) {
    if (detail?.formattedPrice && Number.isFinite(Number(detail.price))) {
      return detail;
    }

    const pricing = window.WMPRxDynamicPricing || window.WMPFramesStartingAt;

    if (typeof pricing?.getStartingPrice === 'function') {
      return pricing.getStartingPrice(detail?.variant || null);
    }

    const product = getProductData();
    const variant = getCurrentVariant(product, detail?.variant || null);
    const lensOptionPrice = Number(pricing?.lensOptionPrice) || 0;

    if (!variant || !Number.isFinite(lensOptionPrice)) return null;

    const price = variant.price + lensOptionPrice;

    return {
      variant,
      variantId: variant.id,
      lensOptionPrice,
      price,
      formattedPrice: formatMoney(price)
    };
  }

  function escapeHtml(value) {
    const escapeNode = document.createElement('textarea');
    escapeNode.textContent = value;
    return escapeNode.innerHTML;
  }

  function renderListItem(content) {
    return `
      <li class="rx-value-prop__item">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                      <path fill-rule="evenodd" clip-rule="evenodd" d="M20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10ZM14.0303 6.96967C14.3232 7.26256 14.3232 7.73744 14.0303 8.03033L9.03033 13.0303C8.73744 13.3232 8.26256 13.3232 7.96967 13.0303L5.96967 11.0303C5.67678 10.7374 5.67678 10.2626 5.96967 9.96967C6.26256 9.67678 6.73744 9.67678 7.03033 9.96967L8.5 11.4393L10.7348 9.2045L12.9697 6.96967C13.2626 6.67678 13.7374 6.67678 14.0303 6.96967Z" fill="#71533E"/>
                    </svg>
        <span class="rx-value-prop__item-text">${content}</span>
      </li>
    `;
  }

  function normalizeItemsMarkup(source) {
    const wrapper = document.createElement('div');
    wrapper.innerHTML = source || '';

    const listItems = Array.from(wrapper.querySelectorAll('li'))
      .map((item) => item.innerHTML.trim())
      .filter(Boolean);

    if (listItems.length) {
      return listItems.map(renderListItem).join('');
    }

    const blockItems = Array.from(wrapper.querySelectorAll('p, div'))
      .map((item) => item.textContent.trim())
      .filter(Boolean);
    const textItems = blockItems.length ? blockItems : wrapper.textContent.split(/\n+/).map((item) => item.trim()).filter(Boolean);

    return textItems.map((item) => renderListItem(escapeHtml(item))).join('');
  }

  function getVariantCopy(section, variantId) {
    if (!variantId) return null;
    return section.querySelector(`[data-rx-variant-copy][data-variant-id="${variantId}"]`);
  }

  function updateSectionCopy(section, variantId) {
    const useVariantText = section.dataset.useVariantText === 'true';
    const headingTarget = section.querySelector('[data-rx-heading-text]');
    const listTarget = section.querySelector('[data-rx-included-list]');
    const defaultItems = section.querySelector('template[data-rx-default-included-list]');
    const variantCopy = useVariantText ? getVariantCopy(section, variantId) : null;
    const variantHeadline = variantCopy?.dataset.headline?.trim();
    const variantItems = variantCopy?.querySelector('template[data-rx-variant-items]');

    if (headingTarget) {
      headingTarget.textContent = variantHeadline || section.dataset.defaultHeading || '';
    }

    if (!listTarget) return;

    const itemsMarkup = variantItems?.innerHTML?.trim() || defaultItems?.innerHTML?.trim() || '';
    const normalizedItems = normalizeItemsMarkup(itemsMarkup);

    if (normalizedItems) {
      listTarget.innerHTML = normalizedItems;
    }
  }

  function updateSectionPrices(section, priceData) {
    if (!priceData?.formattedPrice) return;

    const designerMarkupCents = Number(section.dataset.designerMarkupCents) || 0;
    const designerPrice = Number(priceData.price) + designerMarkupCents;

    section.querySelectorAll('[data-rx-everything-included-price], [data-rx-animation-wmp-price]').forEach((element) => {
      element.textContent = priceData.formattedPrice;
    });

    section.querySelectorAll('[data-rx-designer-price]').forEach((element) => {
      element.textContent = formatMoney(designerPrice);
    });
  }

  function updateSections(detail = null) {
    const priceData = getPriceData(detail);
    if (!priceData) return;

    getSections().forEach((section) => {
      updateSectionCopy(section, String(priceData.variantId || priceData.variant?.id || ''));
      updateSectionPrices(section, priceData);
    });
  }

  function animateSection(section) {
    const animation = section.querySelector('[data-rx-animation]');
    if (!animation || animation.dataset.rxAnimationReady === 'true') return;

    animation.dataset.rxAnimationReady = 'true';

    if (!('IntersectionObserver' in window)) {
      animation.classList.add('rx-value-prop__animation--active');
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          animation.classList.add('rx-value-prop__animation--active');
        } else {
          animation.classList.remove('rx-value-prop__animation--active');
        }
      });
    }, {
      threshold: 0.3
    });

    observer.observe(animation);
  }

  function initSections(root = document) {
    getSections(root).forEach((section) => {
      animateSection(section);
    });

    updateSections();
    window.setTimeout(updateSections, 0);
    window.setTimeout(updateSections, 300);
  }

  function subscribeVariantChange() {
    if (variantSubscriptionReady) return;
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined' || !PUB_SUB_EVENTS.variantChange) return;

    variantSubscriptionReady = true;
    subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
      updateSections({ variant: data?.variant });
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    initSections();
    subscribeVariantChange();

    document.addEventListener('click', (event) => {
      if (!event.target.closest('.product-section__variant-thumbnail')) return;
      window.setTimeout(updateSections, 0);
    }, true);
  });

  document.addEventListener('shopify:section:load', (event) => {
    initSections(event.target);
    subscribeVariantChange();
  });

  window.addEventListener('wmp:rx-price-change', (event) => {
    updateSections(event.detail);
  });
})();
